import React, { useState, useEffect } from 'react';
import { Box, Stack, TextField } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';

import parse, { DOMNode } from 'html-react-parser';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';
import { TextContentBlock } from '../../../_types/dtb';
import { BlockCommonProps } from './BlockSelector';
import { useDTBLibraryContext } from '../../context';
import DTBContentEditor from './DTBContentEditor';

interface ContentBlock extends BlockCommonProps {
  block: TextContentBlock;
}

const ContentBlock: React.FC<ContentBlock> = (props) => {
  const { dtbData } = useDTBLibraryContext();
  const [titleValue, setTitleValue] = useState(props.block.title || '');

  useEffect(() => {
    setTitleValue(props.block.title || '');
  }, [props.block.title]);

  const handleSaveContent = (html: string) => {
    const newTextBlock = {
      ...props.block,
      content: html,
    };
    props.onSave(props.index, newTextBlock);
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitleValue(e.target.value);
  };

  const handleTitleBlur = () => {
    if (titleValue !== props.block.title) {
      const newBlock = {
        ...props.block,
        title: titleValue,
      };
      props.onSave(props.index, newBlock);
    }
  };

  return (
    <Stack spacing={2}>
      {props.isEditMode ? (
        <>
          <TextField
            label={t('dtbs.library.detail.content.blockTitle')}
            value={
              titleValue
                ?.replace(/<[^>]*>/g, '')
                ?.replace(/&amp;/g, '&')
                ?.replace(/&lt;/g, '<')
                ?.replace(/&gt;/g, '>')
                ?.replace(/&quot;/g, '"')
                ?.replace(/&#39;/g, "'") ?? ''
            }
            onChange={handleTitleChange}
            onBlur={handleTitleBlur}
            fullWidth
          />
          <DTBContentEditor
            id={`content_${props.index}`}
            contentHTML={props.block.contentEditable || ''}
            onSave={handleSaveContent}
            isEditable
            manualId={dtbData?.manual?.id}
          />
        </>
      ) : (
        <Box sx={{ minHeight: 0, overflow: 'auto' }}>
          {parse(props.block.content || 'Enter a description', {
            replace(node: DOMNode, ind: number) {
              return PolicyContentHelper.handleContent(node, ind);
            },
          })}
        </Box>
      )}
    </Stack>
  );
};

export default ContentBlock;
